import { Record } from '@common/data-models/records/record';
import { PSTFieldNames } from "@common/data-models/fields/pst-field-names";
import { ObjectTypes } from "@common/enums/object-types";
export class ContactRecord extends Record{

    public initialize() {
        this.type = ObjectTypes.CONTACT;
        super.initialize();
    }

    public get name(): string { return this.getAs<string>(PSTFieldNames.ContactName); }
    public set name(value: string) { this.set(PSTFieldNames.ContactName, value); }

    public get jobTitle(): string { return this.getAs<string>(PSTFieldNames.ContactJobTitle); }
    public set jobTitle(value: string) { this.set(PSTFieldNames.ContactJobTitle, value); }
    
    public get phone(): string { return this.getAs<string>(PSTFieldNames.ContactPhone); }
    public set phone(value: string) { this.set(PSTFieldNames.ContactPhone, value); }
    
    public get email(): string { return this.getAs<string>(PSTFieldNames.ContactEmail); }
    public set email(value: string) { this.set(PSTFieldNames.ContactEmail, value); }
    
    public get workAddress(): string { return this.getAs<string>(PSTFieldNames.ContactWorkAddress); }
    public set workAddress(value: string) { this.set(PSTFieldNames.ContactWorkAddress, value); }

}



//, the basic contact details (name, title, phone, email) 
